module.exports = __webpack_public_path__ + "img/banner.43b69b1d.png";